import { render } from "./DistributorBreadcrumbs.vue?vue&type=template&id=8271b7ca&scoped=true"
import script from "./DistributorBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./DistributorBreadcrumbs.vue?vue&type=script&lang=js"

import "./DistributorBreadcrumbs.vue?vue&type=style&index=0&id=8271b7ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8271b7ca"]])

export default __exports__